import type { ButtonBlock as ButtonBlockDoc } from '../types';

/**
 * Tlačítko. Akce: odeslat formulář (type=submit), odkaz (vlastní origin /
 * tel: / mailto:), zavřít, nebo zkopírovat kód jiného bloku.
 */
export function ButtonBlock({
  block,
  onSubmit,
  onClose,
  onLink,
  onCopyCode,
}: {
  block: ButtonBlockDoc;
  onSubmit: () => void;
  onClose: () => void;
  onLink: (href: string) => void;
  onCopyCode: (blockId: string) => void;
}) {
  const className = `layer-button layer-button-${block.style}`;

  if (block.action.kind === 'submit') {
    // Formulářové odeslání řeší <form onSubmit>; klik jen zaznamenáme.
    return (
      <button type="submit" className={className} onClick={onSubmit}>
        {block.label}
      </button>
    );
  }

  if (block.action.kind === 'link') {
    const href = block.action.href;
    return (
      <a
        className={className}
        href={href}
        onClick={() => onLink(href)}
        {...(isExternalLink(href) ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {block.label}
      </a>
    );
  }

  if (block.action.kind === 'copy_code') {
    const blockId = block.action.blockId;
    return (
      <button type="button" className={className} onClick={() => onCopyCode(blockId)}>
        {block.label}
      </button>
    );
  }

  // close
  return (
    <button type="button" className={className} onClick={onClose}>
      {block.label}
    </button>
  );
}

function isExternalLink(href: string): boolean {
  return /^https?:\/\//i.test(href);
}
